<template>
  <a-modal
    v-model:visible="gDetailVisible"
    :title="curGaugeType === 0 ? '随访量表 ' : '指导意见'"
    class="gDetailModal"
    :footer="null"
    width="772px"
  >
    <span id="topTarget"></span>
    <CheckList :survey="survey" :curGaugeType="curGaugeType" />
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineProps, watch } from 'vue'
import CheckList from './checkList.vue'
import { gaugeDetailApi, gaugeDetailApiNew } from '@/api/workPlace/gauge.js'
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
})

watch(
  () => props.params,
  nV => {
    gaugeDetail(nV)
  },
  { deep: true }
)

const survey = ref({})
const curGaugeType = ref(0)
const gaugeDetail = async query => {
  if (query.surveyId) {
    survey.value = await gaugeDetailApi(query)
  } else {
    const res = await gaugeDetailApiNew(query)
    survey.value = res[0]
  }
  curGaugeType.value = survey.value.guidanceStatus
  toTop()
}

const toTop = () => {
  const target = document.getElementById('topTarget')
  target.scrollIntoView({ block: 'start', behavior: 'smooth' })
}
const gDetailVisible = ref(false)
defineExpose({
  gDetailVisible
})
</script>

<style lang="scss">
.gDetailModal {
  .ant-modal-body {
    padding: 16px 86px;
    max-height: 760px;
    overflow: auto;
  }
}
</style>
